/* eslint-disable max-lines-per-function */
/* eslint-disable react/no-children-prop */
import React, { lazy } from "react";
import { Route, Navigate } from "react-router-dom";
import RoleGuard from "../auth/RoleGuard.js";
const Home = lazy(() => import("../Landing/Home"));
const LoginPage = lazy(() => import("../Landing/LoginPage"));
const Options = lazy(() => import("../Landing/Options"));
const B2COtpPage = lazy(() => import("../Landing/B2COtpPage.js"));
const Steps = lazy(() => import("../stepper/Steps"));
const Onboarding = lazy(() => import("../onboarding/Onboarding"));
const FlowSelectionOptions = lazy(() =>
  import("../onboarding/FlowSelectionOptions")
);
const MatchMentorFlowCoolPage = lazy(() =>
  import("../onboarding/MatchMentorFlowCoolPage")
);
const IndividualBasicInfo = lazy(() =>
  import("../stepper/B2CFlow/IndividualBasicInfo")
);
const IndividualGetPlan = lazy(() =>
  import("../stepper/B2CFlow/IndividualGetPlan")
);
const B2CSteps = lazy(() => import("../stepper/B2CFlow/B2CSteps"));

const Dashboard = lazy(() => import("../Dashboard/Dashboard"));
const Profile = lazy(() => import("../Pages/Profile"));
import MentorSteps from "../mentorStepper/MentorSteps";
import MyApplications from "../Dashboard/MyApplications";
// import { loader as documentLoader } from "../Documents/DocumentsList";
import SchoolAdminBasicInfo from "../Landing/SchoolAdminBasicInfo.js";
import Fallback from "../../utils/Fallback.js";
// const Documents = lazy(() => import("../Documents/Documents"));
const DocumentsList = lazy(() => import("../Documents/DocumentsList"));
const DocumentForm = lazy(() => import("../Documents/DocumentForm"));
const DocumentDetails = lazy(() => import("../Documents/DocumentDetails"));
const MessageLanding = lazy(() => import("../Messages/MessageLanding"));
const MessageEmpty = lazy(() => import("../Messages/MessageEmpty"));
const MessageChat = lazy(() => import("../Messages/MessageChat"));
const Meetings = lazy(() => import("../Meetings/Meetings"));
const Layout = lazy(() => import("../../layout/Layout.jsx"));
const Mentors = lazy(() => import("../Mentors/Mentors"));
const MatchedMentors = lazy(() => import("../Mentors/MatchedMentors"));
const MentorBio = lazy(() => import("../Mentors/MentorBio"));
const MentorDashboard = lazy(() => import("../Dashboard/MentorDashboard.js"));
const PlanCreditsDashboard = lazy(() =>
  import("../PlansCredits/PcDashboard.js")
);
const StudentsList = lazy(() => import("../Students/StudentsList.js"));
const MentorListForAdmin = lazy(() =>
  import("../Mentors/MentorListForAdmin.js")
);
const SupportHelp = lazy(() => import("../Support/SupportHelp.js"));
const SchoolAdminDashboard = lazy(() =>
  import("../Dashboard/SchoolAdminDashboard.js")
);
const SuperAdminDashboard = lazy(() =>
  import("../Dashboard/SuperAdminDashboard.js")
);
const ManagePlan = lazy(() => import("../Pages/ManagePlan.js"));
const MyEarnings = lazy(() => import("../Mentors/MyEarnings.js"));
const Administrator = lazy(() => import("../Pages/Administrator.js"));
const Payments = lazy(() => import("../Pages/Payments.js"));
const Services = lazy(() => import("../Pages/Services.js"));
const StudentApplications = lazy(() => import("../Students/MyApplications.js"));
const StudentDocument = lazy(() => import("../Dashboard/StudentDocument.js"));
const CreditRequests = lazy(() => import("../Credit/CreditRequests.js"));
const MyMaterials = lazy(() => import("../Dashboard/MyMaterials.js"));
const MyMaterialsPage = lazy(() => import("../Dashboard/MyMaterialPage.js"));
const Chatbot = lazy(() => import("../Chatbot/Chatbot"));
const ChatPage = lazy(() => import("../Chat/ChatPage"));
const SuperadminMeetingList = lazy(() =>
  import("../Meetings/SuperAdminMeetingList.js")
);
const TestPrep = lazy(() => import("../TestPrep/TestPrep.js"));
const Packages = lazy(() => import("../Packages/Packages.js"));

const ResetPassword = lazy(() => import("../Landing/ResetPassword.js")); //RP

function PrivateRoute() {
  return (
    <Route path="/">
      <Route path="*" element={<Navigate to="/" replace />} />
      <Route index element={<Home />} />
      <Route
        path="user"
        element={<Layout />}
        children={[
          <Route
            index
            path="dashboard"
            key="dashboard"
            element={
              <RoleGuard>
                <Dashboard />
              </RoleGuard>
            }
          />,
          <Route
            path="newDocument"
            key="newDocument"
            element={
              <RoleGuard>
                <DocumentForm />
              </RoleGuard>
            }
          />,
          <Route
            path="documents/:docId"
            key="docId"
            element={
              <RoleGuard>
                <DocumentDetails />
              </RoleGuard>
            }
          />,
          <Route
            path="meetings"
            key="meetings"
            element={
              <RoleGuard>
                <Meetings />
              </RoleGuard>
            }
          />,
          <Route
            path="superAdminMeetings"
            key="superAdminMeetings"
            element={
              <RoleGuard>
                <Meetings />
              </RoleGuard>
            }
          />,
          <Route
            path="messages"
            key="messages"
            element={
              <RoleGuard>
                <MessageLanding />
              </RoleGuard>
            }
          />,
          <Route
            path="application"
            key="application"
            element={
              <RoleGuard>
                <MyApplications />
              </RoleGuard>
            }
          />,
          <Route
            path="documents"
            key="documents"
            element={
              <RoleGuard>
                <DocumentsList />
              </RoleGuard>
            }
          />,
          <Route
            path="mentorDashboard"
            key="mentorDashboard"
            element={
              <RoleGuard>
                <MentorDashboard />
              </RoleGuard>
            }
          />,
          <Route
            path="planDashboard"
            key="pcDashboard"
            element={
              <RoleGuard>
                <PlanCreditsDashboard />
              </RoleGuard>
            }
          />,
          <Route
            path="studentsList"
            key="studentsList"
            element={
              <RoleGuard>
                <StudentsList />
              </RoleGuard>
            }
          />,
          <Route
            path="mentorListForAdmin"
            key="mentorListForAdmin"
            element={
              <RoleGuard>
                <MentorListForAdmin />
              </RoleGuard>
            }
          />,
          <Route
            path="superAdminMeetingList"
            key="superAdminMeetingList"
            element={
              <RoleGuard>
                <SuperadminMeetingList />
              </RoleGuard>
            }
          />,
          <Route
            path="help"
            key="help"
            element={
              <RoleGuard>
                <SupportHelp />
              </RoleGuard>
            }
          />,
          <Route
            path="schoolAdmin"
            key="schoolAdmin"
            element={
              <RoleGuard>
                <SchoolAdminDashboard />
              </RoleGuard>
            }
          />,
          <Route
            path="superAdmin"
            key="superAdmin"
            element={
              <RoleGuard>
                <SuperAdminDashboard />
              </RoleGuard>
            }
          />,
          <Route
            path="studentDocuments"
            key="studentDocuments"
            element={
              <RoleGuard>
                <StudentDocument />
              </RoleGuard>
            }
          />,
          <Route
            path="managePlan"
            key="managePlan"
            element={
              <RoleGuard>
                <ManagePlan />
              </RoleGuard>
            }
          />,
          <Route
            path="myEarnings"
            key="myEarnings"
            element={
              <RoleGuard>
                <MyEarnings />
              </RoleGuard>
            }
          />,
          <Route
            path="administratorsList"
            key="administrator"
            element={
              <RoleGuard>
                <Administrator />
              </RoleGuard>
            }
          />,
          <Route
            path="payments"
            key="payments"
            element={
              <RoleGuard>
                <Payments />
              </RoleGuard>
            }
          />,
          <Route
            path="services"
            key="services"
            element={
              <RoleGuard>
                <Services />
              </RoleGuard>
            }
          />,
          <Route
            path="myApplications"
            key="myapplications"
            element={
              <RoleGuard>
                <StudentApplications />
              </RoleGuard>
            }
          />,
          <Route
            path="applications"
            key="applications"
            element={
              <RoleGuard>
                <StudentApplications />
              </RoleGuard>
            }
          />,
          <Route
            path="applications/:studentId"
            key="applications"
            element={
              <RoleGuard>
                <StudentApplications />
              </RoleGuard>
            }
          />,
          <Route
            path="creditRequests"
            key="creditRequests"
            element={
              <RoleGuard>
                <CreditRequests />
              </RoleGuard>
            }
          />,
          <Route
            path="materials"
            key="materials"
            element={
              <RoleGuard>
                <MyMaterials />
              </RoleGuard>
            }
          />,
          <Route
            path="studentMaterials"
            key="studentMaterials"
            element={
              <RoleGuard>
                <MyMaterialsPage />
              </RoleGuard>
            }
          />,
          <Route
            path="testPrep"
            key="testPrep"
            element={
              <RoleGuard>
                <TestPrep />
              </RoleGuard>
            }
          />,
          <Route
            path="chatBot"
            element={
              <RoleGuard>
                <Chatbot />
              </RoleGuard>
            }
            key="chatBot"
          />,
          <Route
            path="chat"
            element={
              <RoleGuard>
                <ChatPage />
              </RoleGuard>
            }
            key="chat"
          />,
        ]}
      />
      {/* RP */}
      <Route
        path="forgotPassword/:token"
        key="forgotPassword"
        element={<ResetPassword />}
      />
      <Route path="options" element={<Options />} />
      <Route path="otp" element={<B2COtpPage />} />
      <Route
        path="flowSelectionOptions"
        key="flowSelectionOptions"
        element={
          <RoleGuard>
            <FlowSelectionOptions />
          </RoleGuard>
        }
      />
      <Route
        path="package"
        element={
          <RoleGuard>
            <Packages />
          </RoleGuard>
        }
        key="package"
      />
      <Route
        path="matchMentorFlowCoolPage"
        key="matchMentorFlowCoolPage"
        element={
          <RoleGuard>
            <MatchMentorFlowCoolPage />
          </RoleGuard>
        }
      />
      <Route
        path="individualBasicInfo"
        key="individualBasicInfo"
        element={
          <RoleGuard>
            <IndividualBasicInfo />
          </RoleGuard>
        }
      />
      <Route
        path="individualGetPlan"
        key="individualGetPlan"
        element={
          <RoleGuard>
            <IndividualGetPlan />
          </RoleGuard>
        }
      />
      <Route
        path="b2cSteps"
        element={
          <RoleGuard>
            <B2CSteps />
          </RoleGuard>
        }
      />
      <Route
        path="fallback"
        key="fallback"
        element={
          <RoleGuard>
            <Fallback />
          </RoleGuard>
        }
      />
      <Route path="login" element={<LoginPage />} />
      <Route path="onboarding" element={<Onboarding />} />
      <Route
        path="steps"
        element={
          <RoleGuard>
            <Steps />
          </RoleGuard>
        }
      />
      <Route
        path="profile"
        element={
          <RoleGuard>
            <Profile />
          </RoleGuard>
        }
      />
      <Route
        path="studentProfile"
        element={
          <RoleGuard>
            <Profile />
          </RoleGuard>
        }
        key="studentProfile"
      />
      ,
      <Route
        path="mentorProfile"
        element={
          <RoleGuard>
            <Profile />
          </RoleGuard>
        }
      />
      ,
      <Route
        path="MentorSteps"
        element={
          <RoleGuard>
            <MentorSteps />
          </RoleGuard>
        }
        key="MentorSteps"
      />
      ,
      <Route
        path="messageBlank"
        element={
          <RoleGuard>
            <MessageEmpty />
          </RoleGuard>
        }
        key="messageBlank"
      />
      ,
      <Route
        path="messageChat"
        element={
          <RoleGuard>
            <MessageChat />
          </RoleGuard>
        }
        key="messageChat"
      />
      ,
      <Route
        path="mentors"
        element={
          <RoleGuard>
            <Mentors />
          </RoleGuard>
        }
        key="mentors"
      />
      ,
      <Route
        path="user/matchedMentors"
        element={
          <RoleGuard>
            <MatchedMentors />
          </RoleGuard>
        }
        key="matchedMentors"
      />
      ,
      <Route
        path="mentorBio"
        element={
          <RoleGuard>
            <MentorBio />
          </RoleGuard>
        }
        key="mentorBio"
      />
      ,
      <Route
        path="schoolAdminBasicInfo"
        element={
          <RoleGuard>
            <SchoolAdminBasicInfo />
          </RoleGuard>
        }
        key="schoolAdminBasicInfo"
      />
    </Route>
  );
}

export default PrivateRoute;
